import { z } from 'zod';
import { optionalEditFormTrimmedString, optionalNullableDateInput, optionalUuidString, requiredUuidString, } from '../zod-helpers/index.js';
import { PURCHASE_ORDER_CONSTRAINTS } from './constraints.js';
const optionalDateFormString = z
    .string()
    .optional()
    .superRefine((value, context) => {
    if (!value)
        return;
    if (!optionalNullableDateInput.safeParse(value).success) {
        context.addIssue({ code: 'custom', message: 'Invalid date.' });
    }
});
export const purchaseOrderEditFormSchema = z.object({
    locationGroupId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label} is required.`, `Invalid ${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`),
    deliverTo: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.deliverTo.maxLength),
    shipToName: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.shipToName.maxLength),
    shipToAddress: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.shipToAddress.maxLength),
    shipToCity: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.shipToCity.maxLength),
    shipToZip: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.shipToZip.maxLength),
    note: optionalEditFormTrimmedString(PURCHASE_ORDER_CONSTRAINTS.note.maxLength),
    dateFirstShip: optionalDateFormString,
    dateConfirmed: optionalDateFormString,
});
// The expected-delivery-only edit mode (PO already Issued/Shipped/Partially Received) only
// renders dateFirstShip — locationGroupId and the other header fields stay out of the DOM, so
// they must not be required here. `purchaseOrderToEditFormState` still seeds locationGroupId
// from the current record (or '' if unset), and optionalUuidString treats '' as "not selected".
export const purchaseOrderEditExpectedDeliveryOnlyFormSchema = purchaseOrderEditFormSchema.extend({
    locationGroupId: optionalUuidString(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`),
});
//# sourceMappingURL=update-form.js.map